import * as ActionTypes from './actionTypes'

export const fetchSuccess = (results) => ({
  type: ActionTypes.FETCH_SUCCESS,
  results,
})

export const fetchStart = () => ({
  type: ActionTypes.FETCH_START,
})

export const fetchFail = (error) => ({
  type: ActionTypes.FETCH_FAILURE,
  error,
})

export const selectResults = (resultIds) => ({
  type: ActionTypes.SELECT_RESULTS,
  resultIds,
})

export const clearSelection = () => ({
  type: ActionTypes.CLEAR_SELECTION,
})

export const hoverResultStart = (resultId) => ({
  type: ActionTypes.HOVER_RESULT_START,
  resultId,
})

export const hoverResultEnd = (resultId) => ({
  type: ActionTypes.HOVER_RESULT_END,
  resultId,
})
